var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[((_vm.show))?_c('Index',{attrs:{"pageConfig":(_vm.pageConfig),"info":(_vm.info)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }